import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import css from 'css';

import CardPayment from './CardPayment';
import InvoicePayment from './InvoicePayment';
import Terms from './Terms';

import { gtmPush } from 'helpers';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutOpportunityPaymentMethod,
} from 'store';

const StripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

const Wrapper = styled.section``

const Description = styled.p`
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 30px;
`;

const HelpBox = styled.div`
    width: 100%;
    background-color: #F3E2E1;
    padding: 30px;
    margin-bottom: 30px;

    .title {
        padding-left: 30px;
        color: #133A6C;
        font-weight: bold;
    }

    .url {
        padding-left: 30px;
        color: #214573;
        font-weight: 500;
        text-decoration: underline;
    }
`;

const PaymentOptions = styled.div`
    margin-bottom: 30px;

    ul {
        display: flex;
        flex-flow: column;
        margin: 0;
        padding: 0;
        list-style: none;
        overflow: hidden;

        li {
            display: inline-flex;
            color: #FFF;
            padding-bottom: 20px;

            input[type=radio] {
                position: absolute;
                visibility: hidden;
            }

            label {
                display: inline-block;
                padding: 0 25px 0 40px;
                z-index: 9;
                cursor: pointer;
                -webkit-transition: all 0.25s linear;

                b {
                    font-weight: bold;
                }
            }

            .check {
                display: block;
                position: absolute;
                border: 1px solid #95B9DB;
                border-radius: 100%;
                height: 26px;
                width: 26px;
                cursor: pointer;
                z-index: 5;
                transition: border .25s linear;
                -webkit-transition: border .25s linear;

                &::before {
                    display: block;
                    position: absolute;
                    content: '';
                    border-radius: 100%;
                    height: 10px;
                    width: 10px;
                    top: 7px;
                    left: 7px;
                    margin: auto;
                    transition: background 0.25s linear;
                    -webkit-transition: background 0.25s linear;
                }
            }
        }
    }

    input[type=radio]:checked {
        ~ .check {
            background: ${css.colors.main};
            border: 1px solid #FFF;

            &::before{
                background: #FFF;
            }
        }
    }
`;

const TermsPopup = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
`;

class PaymentMethods extends Component {
    
    componentDidMount() {
        if (this.props.opportunity.amount !== this.props.opportunity.payableAmount) {
            this.props.setCheckoutTitle('Registreringsavgift');
        } else {
            this.props.setCheckoutTitle('Bestilling');
        }
        this.props.setCheckoutSubtitle('');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Bestilling',
            'pageURI': '/checkout/betaling', 
        });

        this.props.setCheckoutOpportunityPaymentMethod('invoice');
    }

    _setPaymentMethod = (event) => {
        this.props.setCheckoutOpportunityPaymentMethod(event.target.value);
    }

    _onSubmit() {
        return false;
    }

    render() {
        const { payableAmount, paymentMethod } = this.props.opportunity;

        return (
            <Wrapper>
                <React.Fragment>
                    <Terms onRef={ref => (this.termsRef = ref)} />
                </React.Fragment>
                {this.props.opportunity.amount !== this.props.opportunity.payableAmount ?
                    <Description>
                        Du betaler bare registreringsavgift, <b>{parseInt(payableAmount).toLocaleString('de-DE')},-</b> i denne omgang.
                        Dette er ikke en tilleggskostnad, beløpet vil bli fratrukket totalbeløpet for dine skolepenger.
                    </Description>
                    :
                    <Description>
                        Pris <b>{parseInt(payableAmount).toLocaleString('de-DE')},-</b>.
                    </Description>
                }
                <PaymentOptions>
                    {this.props.opportunity.amount !== this.props.opportunity.payableAmount ?
                        <ul>
                            <li>
                                <label for="invoice"> Du betaler ingenting nå. Faktura blir sendt ved skolestart (august for høstsemesteret og januar for vårsemesteret) </label>
                                <input onChange={this._setPaymentMethod.bind(this)} type="radio" checked={paymentMethod === 'invoice'} id="invoice" value="invoice" name="selector" />
                                <div className="check"><div className="inside"></div></div>
                            </li>
                        </ul>
                        :
                        <ul>
                            <li>
                                <label for="invoice"> Du betaler ingenting nå. Faktura blir sendt ved skolestart (august for høstsemesteret og januar for vårsemesteret) </label>
                                <input onChange={this._setPaymentMethod.bind(this)} type="radio" checked={paymentMethod === 'invoice'} id="invoice" value="invoice" name="selector" />
                                <div className="check"><div className="inside"></div></div>
                            </li>
                        </ul>
                    }
                </PaymentOptions>
                {paymentMethod === 'invoice' &&
                    <InvoicePayment termsRef={this.termsRef} />
                }
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    order: state.order
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutOpportunityPaymentMethod,
}

export default withRouter(connect(mapStateToProps, actions)(PaymentMethods));


// WEBPACK FOOTER //
// ./src/partials/Checkout/PaymentMethods.js